import { Award, blankAward } from './award';
import { Contact, blankContact } from './contact';
import { Country } from './country';
import { CustomerReference } from './customer-reference';
import { DocumentMetadata } from './document-metadata';
import { NominationPartnerType } from './nomination-partner-type';
import { NominationStatusType } from './nomination-status';
import { NominationWebsite } from './nomination-website';
import { Organization, createOrganizationDraft } from './organization';
import { OrganizationType } from './organization-type';
import { Owner, blankOwner } from './owner';
import { PartnerContact } from './partner-contact';

export interface Nomination {
  nominationId: number;
  nominationNumber: string;
  name: string;
  abstract: string;
  marketplaceOfferUrl?: string;
  status: NominationStatusType;
  organization?: Organization;
  contacts: Contact[];
  owner: Owner;
  award: Award;
  associatedCountries: Country[];
  jointNominees: Organization[];
  supportingDocuments: DocumentMetadata[];
  customerReferences: CustomerReference[];
  websites: NominationWebsite[];
  partnerTypes: NominationPartnerType[];
  partnerContacts: PartnerContact[];
}

export function blankNomination(): Nomination {
  return {
    nominationId: 0,
    nominationNumber: '',
    name: '',
    abstract: '',
    status: 'Incomplete',
    owner: blankOwner(),
    award: blankAward(),
    associatedCountries: [],
    organization: createOrganizationDraft(OrganizationType.Main),
    contacts: [blankContact()],
    jointNominees: [],
    supportingDocuments: [],
    customerReferences: [],
    websites: [],
    partnerTypes: [],
    partnerContacts: []
  };
}
